import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useAnalytics } from '../../utils/analytics-provider/analytics-provider';
import { Hero } from './hero';
import { QuickAnswers } from './quick-answers';
import { BrowseTopics } from './browse-topics';
import { PopularArticles } from './popular-articles';
import { ContactFlow } from './contact-flow';
import { HomeProvider } from './context';
import { Experiment, When } from '@carvana/core-experiment';
import { getUserState } from '@carvana/core-auth';
import { useSupportContext } from '../../helpers/context-provider';
import { StyledSpinner } from '../search/components/loading/styles';

const Wrapper = styled.div`
  margin: 0 auto;
  min-height: 100vh;
`;

const LoadingWrapper = styled(StyledSpinner)`
  justify-content: center !important;
  margin-top: 4rem !important;
`;

const DefaultHomePage = () => (
  <>
    <QuickAnswers />

    <BrowseTopics />

    <PopularArticles />

    <ContactFlow isContactUsExperiment={true} />
  </>
);
const ExperimentHomePage = () => (
  <>
    <ContactFlow isContactUsExperiment={true} />

    <QuickAnswers />

    <BrowseTopics />

    <PopularArticles />
  </>
);

const callRoutingStatuses = [
  'PostSalesNSF',
  'Registration_Resolution',
  'PostSalesGeneral',
  'PostSalesVehiclePush',
  'SwapsReturns'
];

const isCallRouting = (callRouting) => callRoutingStatuses.includes(callRouting);

const HomeContent = () => {
  const { trackEvent } = useAnalytics();
  const { isLoggedIn, user } = getUserState() || {};
  const { isLoading, callRouting } = useSupportContext() || {};
  const isEligibleForBucketing = !isLoading && isLoggedIn && isCallRouting(callRouting);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    if (mounted && !isLoading && isLoggedIn) {
      trackEvent('home_page_variant_view', {
        isEligibleForBucketing,
        callRouting
      });
    }
  }, [mounted, isEligibleForBucketing, callRouting, trackEvent, isLoggedIn, isLoading]);

  useEffect(() => setMounted(true), []);
  if (!mounted) return <DefaultHomePage />;

  return isLoading ? (
    <LoadingWrapper />
  ) : (
    <Experiment
      name="inventory-ltw-help-auth-contact-us"
      identifier={user?.user_id}
      skipBucketing={!isEligibleForBucketing}
    >
      <When bucket="control">
        <DefaultHomePage />
      </When>

      <When bucket="treatment">
        <ExperimentHomePage />
      </When>
    </Experiment>
  );
};

const HomePage = () => {
  const { trackEvent } = useAnalytics();
  trackEvent('page_hit', { page_hit: 'home' });

  return (
    <HomeProvider>
      <Wrapper>
        <Hero />

        <HomeContent />
      </Wrapper>
    </HomeProvider>
  );
};

export default HomePage;
